import { FieldType, FieldValue, FilterField, Filters, O } from "../../../../../features/ui"
import { useEffect, useState } from "react"
import { DataType } from '../../../../../tables'
import { Vehicle } from "../../../state/types"
import { useVehicleHooks } from "../../../hooks/vehicleHooks"

type Props = {
    vehicles: Vehicle[]
    onSearchStart: () => void
    onSearchDone: (dataTypes: DataType[]) => void
}

const FiltersKey = 'vehicle'

export const VehicleFilters = (props: Props) => {
    const { vehicles, onSearchStart, onSearchDone } = props

    const [searchText, setSearchText] = useState<string>()

    const { searchVehicles } = useVehicleHooks()

    useEffect(() => search(searchText), [vehicles])

    const search = (searchTextParam?: string) => {
        onSearchStart()
        searchVehicles(vehicles, searchTextParam).then(searchedList => {
            setTimeout(() => onSearchDone(searchedList as DataType[]), 100)
        })
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText)
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar por nombre o patente',
        icon: 'search',
        onChange: handleSearch
    }

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
        />
    )
}
